import React from "react";
import Mission from "../components/Mission/Mission";
import CoreValues from "../components/CoreValues/CoreValues";
import Responsibility from "../components/Responsibilty/Responsibilty";
import Team from "../components/Team/Team";
import WarehouseImg from "../images/warehouse-bg.jpg";
import Location from "../components/Location/Location";

const About = () => {
  return (
    <div>
      <div className="about-container">
        <section className="about-hero">
          <img src={WarehouseImg} alt="Factory" className="about-hero-image" />

          <div className="about-hero-text">
            <h1>RISEN STAR GOODS</h1>
            <h2>Excellence in Global Food Export</h2>
            <p>Committed to Quality, Sustainability and Reliability</p>
          </div>
        </section>
        <Mission />
        <Location />
        <CoreValues />
        <Responsibility />
        <Team />
      </div>
    </div>
  );
};

export default About;
